module.exports = __webpack_public_path__ + "assets/img/dialog-bg@3x.19e39dc0.png";